var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiamiBeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-1,\n      .cls-2 {\n        fill: #134b94;\n      }\n\n      .cls-3 {\n        fill: #26abc6;\n      }\n\n      .cls-3,\n      .cls-4,\n      .cls-2,\n      .cls-5,\n      .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: #154a94;\n      }\n\n      .cls-5 {\n        fill: #ce7d99;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.5,
    cy: 51.5,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m72.02,78.37c6.77-1.05,11.94-6.91,11.94-13.98V26.69c0-7.81-6.33-14.14-14.14-14.14h-37.7c-5.49-.44-13.98,6.3-14.14,14.14v37.7c0,7.07,5.18,12.92,11.94,13.98m11.62.16h18.85m-18.03-43.05c0-2.25,1.93-8.79,8.78-8.79s8.78,6.53,8.78,8.79v11.06c0,.83-.6,1.5-1.34,1.5h-14.87c-.74,0-1.34-.67-1.34-1.5v-11.06Zm20.25,0c0-2.25,1.93-8.79,8.78-8.79s8.78,6.53,8.78,8.79v11.06c0,.83-.6,1.5-1.34,1.5h-14.87c-.74,0-1.34-.67-1.34-1.5v-11.06Zm7.21,33.63c-2.61,0-4.71-2.11-4.71-4.71s2.11-4.71,4.71-4.71,4.71,2.11,4.71,4.71-2.11,4.71-4.71,4.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.79,
    y: 78.37,
    width: 58.36,
    height: 9.59,
    rx: 4.79,
    ry: 4.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m30.96,12.55c-7.81,0-13.08,7.52-13.08,15.32v37.7c0,7.07,6.32,12.92,13.08,13.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.3,35.62c0-2.25,1.93-8.79,8.78-8.79s8.78,6.53,8.78,8.79v11.06c0,.83-.6,1.5-1.34,1.5h-14.87c-.74,0-1.34-.67-1.34-1.5v-11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.62,35.62c0-2.25,1.93-8.79,8.78-8.79s8.78,6.53,8.78,8.79v11.06c0,.83-.6,1.5-1.34,1.5h-14.87c-.74,0-1.34-.67-1.34-1.5v-11.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32.61,
    cy: 64.54,
    r: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.79,
    y: 52.48,
    width: 67.17,
    height: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.93,
    y: 57.71,
    width: 16,
    height: 19.13,
    rx: 5.66,
    ry: 5.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 51.93,
    cy: 66.14,
    r: 4.71
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiamiBeach);
export default __webpack_public_path__ + "static/media/MiamiBeach.6656770858d12d06d5dcc18235970be9.svg";
export { ForwardRef as ReactComponent };